export function formatDate(date) { 
  if(date.toString().indexOf("GMT")!=-1){
    var date=new Date(date);
     return date.getFullYear().toString() +"-"
      + pad2(date.getMonth() + 1) +"-"
      + pad2(date.getDate()) +" "
      +pad2(date.getHours()) +":"
      +pad2(date.getMinutes()) +":"
      + pad2(date.getSeconds());
  }else{
    return date;
  }
}   

export function formatDateDay(date) { 
  if(date.toString().indexOf("GMT")!=-1){
    var date=new Date(date);
     return date.getFullYear().toString() +"-"
      + pad2(date.getMonth() + 1) +"-"
      + pad2(date.getDate());
  }else{
    return date;
  }
} 
export function formatDateFormHour(date) { 
  var date=new Date(date);
   return date.getFullYear().toString() +"-"
    + (date.getMonth() + 1) +"-"
    + date.getDate() +" " + date.getHours() +":00:00"
} 
export function formatDateForm0(date) { 
  var date=new Date(date);
   return date.getFullYear().toString() +"年"
    + (date.getMonth() + 1) +"月"
    + date.getDate() +"日" + date.getHours() +"时"
} 
//2020年3月24日
export function formatDateForm1(date) { 
    var date=new Date(date);
     return date.getFullYear().toString() +"年"
      + (date.getMonth() + 1) +"月"
      + date.getDate() +"日"
} 
//2020年03月
export function formatDateForm2(date) { 
    var date=new Date(date);
     return date.getFullYear().toString() +"年"
      + pad2(date.getMonth() + 1) +"月"
} 
export function formatDate3(date) { 
    var date=new Date(date);
     return date.getFullYear().toString() +"-"
      + pad2(date.getMonth() + 1) +"-"
      + pad2(date.getDate()) +" 00:00:00";
} 
export function formatDateMonth(date) { 
  var date=new Date(date);
   return date.getFullYear().toString() +"-"
    + pad2(date.getMonth() + 1) ;
} 

//1月6日至12日
export function formatDate4(date) { 
    var date=new Date(date);
    var date2=date.getTime() + 3600 * 1000 * 24 * 6;
    return formatDateForm5(date)+"至"+formatDateForm5(date2);
} 
export function formatDateCustom(date) { 
  var date1=new Date(date[0]);
  var date2=new Date(date[1]);
  return formatDateForm5(date1)+"至"+formatDateForm5(date2);
} 
//03月02日
export function formatDateForm5(date) { 
    var date=new Date(date);
     return (date.getMonth() + 1) +"月" + date.getDate() +"日";
} 
export function pad2(n) { return n < 10 ? '0' + n : n };

export function in_array(stringToSearch, arrayToSearch) {
    for (var s = 0; s < arrayToSearch.length; s++) {
        var thisEntry = arrayToSearch[s].toString();
        if (thisEntry == stringToSearch) {
            return true;
        }
    }
    return false;
}
export function getIcons () {
    var arr=["circle","rect","triangle","diamond","pin","arrow","none","star6"];
    return arr;
  }
export function setColor(value){
    var str="";
    switch(true){
        case value=="NaN":
        str= "gray";
        break;
        case value==null:
        str= "gray";
        break;
        case value<50:
        str= "green";
        break;
        case value<100:
        str= "yellow";
        break;
        case value<150:
        str= "orange";
        break;
        case value<200:
        str= "red";
        break;
        case value<300:
        str= "violet";
        break;
        default:
        str= "black";
        break;
    }
    return str;
}
 //根据值显示AQI不同的RGB和内容
 export function  setRgbAndCon(value){
    var obj={};
    switch(true){
      case value=="NaN":
        obj.rgb="#BEBEBE";
        obj.color='gray';
        break;
      case value==undefined:
        obj.rgb="#BEBEBE";
        obj.color='gray';
        break;
      case value<50:
        obj.rgb="#6aa24f";
        obj.content="优";
        obj.color='green';
        break;
      case value<100:
        obj.rgb="#c4be0f";
        obj.content="良";
        obj.color='yellow';
        break;
      case value<150:
        obj.rgb="#df7d08";
        obj.content="轻度污染";
        obj.color='orange';
        break;
      case value<200:
        obj.rgb="#ef362b";
        obj.content="中度污染";
        obj.color='red';
        break;
      case value<300:
        obj.rgb="#9b1271";
        obj.content="重度污染";
        obj.color='violet';
        break;
      default:
        obj.rgb="#58003d";
        obj.content="严重污染";
        obj.color='black';
        break;
    }
    return obj;
}

export function  setDeviceEvent(data){
  var str="";
  if(data.state_door==1||data.stateDoor==1){
    str="开门"
  }else if(data.state_door==0||data.stateDoor==0){
    str="关门"
  }
  if(data.state_power==0||data.statePower==0){
    str="电力中断"
  }
  if(data.state_power==1||data.statePower==1){
    str="电力恢复"
  }
  if(data.state_send==0||data.stateSend==0){
    str="通信中断"
  }
  if(data.state_device==0||data.stateDevice==0){
    str="设备故障"
  }
  if(str==""){
    str="设备正常"
  }
  return str;
}

export function getQueryObject(variable) { 
    var query = window.location.href.split("?")[1];
    if(query==undefined){
        return(false);
    }
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
    }
    return(false);
 }
 export function translateDataToTreePermission(data) {
  let parents = data.filter(value => value.parentPermission == "0" )      
  let children = data.filter(value => value.parentPermission !== "0")
  let translator = (parents, children) => {
    parents.forEach((parent) => {
      children.forEach((current, index) => {
        if (current.parentPermission === parent.permissionCode) {
          let temp = JSON.parse(JSON.stringify(children));
          if(current.Ischecked){
            parent.Ischecked=true;
          }
          temp.splice(index, 1);
          translator([current], temp);
          typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current];
        }
      })
    })
  }
  translator(parents, children)
  
  return parents
}

export function translateDataToTreeProject(data) {
  let parents = data
  let children = data.filter(value => value.fatherProId !== 0)

  var projectIdAdd=[];

  let translator = (parents, children) => {
    parents.forEach((parent) => {
      children.forEach((current, index) => {
        if (current.fatherProId === parent.projectId) {
          let temp = JSON.parse(JSON.stringify(children));
          if(current.Ischecked){
            parent.Ischecked=true;
          }
          temp.splice(index, 1);
          translator([current], temp);
          typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current];

          projectIdAdd.push(current.projectId)
        }
      })
    })
  }
  translator(parents, children)
  
  return parents.filter(value => !in_array(value.projectId ,projectIdAdd))
 
}

export function factorExcept() {
  return ["primarypollutant","lng","lat","id","time","mn","name","aqi","pm25_aqi","pm10_aqi","so2_aqi","no2_aqi","co_aqi","o3_aqi","o38h_aqi","noiseFiles","dataType",
    "primarypollutant","content","autoFlag","exception","cal","isValid","_XID","reviewtype","exceptionMsg","noisefile","n00009","nightLimitVal","dayLimitVal"];
}	

export function minFactorExcept() {
  return ["n00004","n00005","n00007"]; 
}	

export function hourFactorExcept() {
  return ["n00004","n00005","n00007"];
}	

export function calfactorExcept() {
  return ["primarypollutant","lng","lat","id","time","mn","name","aqi","pm25_aqi","pm10_aqi","so2_aqi","no2_aqi","co_aqi","o3_aqi","o38h_aqi",
    "primarypollutant","content","autoFlag","exception","cal","isValid","end_time","start_time","dar","n00005","n00004","n00007"];
}


export function reviewFactor() {
  return ["n00001","n00004","n00005","n00007","n0000205","n0000210","n0000250","n0000290","n0000295","n00003","n00006"];
}	


// WEBPACK FOOTER //
// ./static/fun.js